// 上传附件相关api
import ObsClient from "esdk-obs-browserjs";
const BUCKET = "xueyuan"//默认桶名
const MODULE = 'exhibition'//文件夹
const endPoint='obs.cn-east-3.myhuaweicloud.com'
let obsClient = null

//单文件上传
export const uploadSingleFile = async (file, { Bucket = BUCKET, module = MODULE } = {}) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (reslove, reject) => {
        //let obsAuth = await getObsAuth(BUCKET)
        let obsClient = getObsClient()
        let fileKey = getFileKey(file, module)
        obsClient.putObject({
            Bucket: Bucket,
            Key: fileKey,
            SourceFile: file
        }, function (err, result) {
            if (err) {
                console.error('Error-->' + err);
                reject(err)
            } else {
                if (result && result.CommonMsg && result.CommonMsg.Status == 200) {
                    reslove({
                        url: `https://${Bucket}.obs.cn-east-3.myhuaweicloud.com/${fileKey}`, fileName: file.name,
                        noIpUrl: fileKey
                    })
                }
                reject(result)
            }
        });
    })
}

// 获取ObsClient实例
function getObsClient() {
    obsClient = new ObsClient({
        access_key_id:'4UXX4J0MURDNINF0R6CV' ,
        secret_access_key: 'zKmFBFTbiXiwvfVsyvgMYaCH3f8LGYZIbyREd48D',
        server: `https://${endPoint}`
    });
    return obsClient
}

/*
 * @Descripttion: 文件路径
 */
function getFileKey(file, module = MODULE,) {
    const suffix = getFileSuffix(file)
    const date = new Date()
    const year = date.getFullYear()
    let month = date.getMonth() + 1
    month = `${month < 10 ? 0 : ''}${month}`
    let day = date.getDate() + 1
    day = `${day < 10 ? 0 : ''}${day}`
    const times = date.getTime()
    const random = Math.floor(Math.random() * 1000000 + 1) //1到1000000的随机整数
    return `${module}/${year}-${month}-${day}/${times}${random}.${suffix}`
}

/*
 * @Descripttion: 获取文件后缀名
 */
function getFileSuffix(file) {
    if (file instanceof File) {
        const fileName = file.name
        return fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
    }
    throw new Error('传入的文件须是File对象')
}


